export const DELETE_USERS_AUTHORITIES_MAP: {[authority: string]: string[]} = {
    ROLE_SUPER_ADMIN: [
        'ROLE_SUPER_ADMIN',
        'ROLE_ADMIN',
        'ROLE_STAFF',
        'ROLE_USER'
    ],
    ROLE_ADMIN: [
        'ROLE_STAFF',
        'ROLE_USER'
    ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/delete-user-authorities.constants.ts